// extracted by mini-css-extract-plugin
module.exports = {"primary":"#2bbbbb","IconRow":"dist-es__IconRow__IconRow","iconLeft":"dist-es__IconRow__iconLeft","iconRight":"dist-es__IconRow__iconRight","content":"dist-es__IconRow__content"};